const seekParamFormatters: Record<string, (link: string, startPosition: number) => string> = {
  'https://www.youtube.com': (link, pos) => `${link}&t=${pos}`,
  'https://sverigesradio.se': (link, pos) => `${link}#${pos}`,
  'https://svtplay.se': (link, pos) => `${link}?position=${pos}`,
  'https://tv.aftonbladet.se': (link, pos) => `${link}?t=${pos}`,
};

export const formatLinkWithSeekParam = (link: string, startPosition?: number) => {
  if (!startPosition) return link;
  for (const domain in seekParamFormatters) {
    if (link.startsWith(domain)) {
      return seekParamFormatters[domain](link, startPosition);
    }
  }
  return link;
};

export default formatLinkWithSeekParam;
